import React from 'react';
import './Loader.css';

const Loader = () => {


  return (
    <div className="loader-container">
      <div className="loader-wrapper">
        <div className="loader">
          <div className="loader-circle"></div>
          <div className="loader-circle"></div>
          <div className="loader-circle"></div>
          <div className="loader-shadow"></div>
          <div className="loader-shadow"></div>
          <div className="loader-shadow"></div>
        </div>
        <div className="loader-text">Chargement...</div>
      </div>
    </div>
  );
};

export default Loader; 